import React from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import PureButton from 'ui/components/pure-controls/PureButton';
import PassportSelector from '../PassportSelector';
import TipsExamples from '../TipsExamples';
import './IntroVerification.scss';

export default class IntroVerification extends React.Component {
  static propTypes = {
    side: PropTypes.string.isRequired,
    nextStep: PropTypes.func.isRequired,
    handleCaptureResult: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    isPassport: PropTypes.bool,
    setPassport: PropTypes.func,
    setManual: PropTypes.func,
  };

  static defaultProps = {
    isPassport: false,
    setPassport: () => null,
    setManual: () => null,
  };

  captureImage = () => {
    const { handleCaptureResult, side, loading, setLoading, isPassport } = this.props;
    let imageType = side === 'front' ? 'DL_FRONT' : 'PDF417_BARCODE';
    if (isPassport) {
      imageType = 'PASSPORT';
    }

    if (loading) {
      return;
    }

    if (isMobile) {
      window.MitekMobileWeb.captureAndProcessImage(
        handleCaptureResult,
        imageType,
        null,
        setLoading,
      );
    }
    this.props.nextStep();
  };

  renderTips() {
    const { isPassport } = this.props;
    return <TipsExamples isPassport={isPassport} />;
  }

  render() {
    const { side, setPassport, isPassport, setManual } = this.props;
    if (isMobile && this.props.loading) {
      return <div className="loading intro-verification__loading" />;
    }

    return (
      <div className="intro-verification">
        {side !== 'back' && (
          <>
            <h1 className="verification__title">Select your form of ID to Capture</h1>
            <PassportSelector onChange={setPassport} value={isPassport} />
          </>
        )}
        <div>
          {isPassport !== null && (
            <>
              <h1 className="verification__title">Upload your ID</h1>
              {!isPassport && isMobile && (
                <p className="verification__description">
                  Now, let's upload the {side} of your id.
                </p>
              )}
              {!isMobile && (
                <>
                  <h4>
                    Capture Your {isPassport ? 'Passport' : "State-issued ID or Driver's License"}
                  </h4>
                  <p className="verification__description">
                    {isPassport
                      ? `Show the TOP and BOTTOM page of your Passport with your picture and signature. ` +
                        `Press Return/Enter key to take a picture.`
                      : `Show the ${side.toUpperCase()} of your State-issued ID. ` +
                        `Press Return/Enter key to take a picture.`}
                  </p>
                </>
              )}
            </>
          )}
        </div>
        {isPassport !== null && (
          <>
            <div className="intro__actions">
              <PureButton onClick={this.captureImage} className="button--primary">
                Click here to start capturing {side} of ID
              </PureButton>
            </div>
            <PureButton
              onClick={setManual}
              className="button--secondary button--upload-photo-instead"
            >
              Upload photo instead
            </PureButton>
            {this.renderTips()}
          </>
        )}
      </div>
    );
  }
}
